import $ from 'jquery';
export default {
  methods: {
    ifFormValid(event, callback) {
      let target = event.target;
      if ($(target).valid()) {
        callback();
      } else {
        $("html, body").animate(
          {
            scrollTop:
              $("label.error").closest(".form-group").eq(0).offset().top - 65,
          },
          500
        );
      }
    },

    validateForm(form, userRules, userMessages, extraOptions) {
      // Optional: To validate rut Chile
      $.validator.addMethod(
        "rut",
        function (value) {
          if (!value) return false;

          value = value.toLowerCase().trim();

          // Verificar formato básico
          if (!/^\d{1,2}\.\d{3}\.\d{3}-[0-9k]$/.test(value)) {
            return false;
          }

          var rut = value.split("-")[0];
          rut = rut.replace(/\./g, "");
          var digit = value.split("-")[1];

          // Verificar que el RUT tenga al menos 7 dígitos
          if (rut.length < 7) return false;

          function dv(T) {
            var M = 0,
              S = 1;
            for (; T; T = Math.floor(T / 10)) {
              S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
            }
            return S ? S - 1 : "k";
          }

          var calculatedDv = dv(rut);
          return calculatedDv.toString() === digit;
        },
        "Por favor, ingresa un RUT válido"
      );

      // Optional: To validate rut is not duplicated in current form
      $.validator.addMethod(
        "rutNoDuplicado",
        function (value, element) {
          if (!value) return true; // No validar si está vacío

          var form = $(element).closest("form");
          var rutInputs = form.find('input[name="rut"]');
          var currentValue = value.toLowerCase().trim();
          var count = 0;

          rutInputs.each(function () {
            if ($(this).val().toLowerCase().trim() === currentValue) {
              count++;
            }
          });

          return count <= 1; // Permitir solo una ocurrencia
        },
        "Este RUT ya está registrado en el formulario"
      );

      // Optional: To validate only digits but allow spaces
      $.validator.addMethod(
        "digitsSpacesAllowed",
        function (value) {
          var pattern = /^([0-9]{2,}\s?)+$/;
          return pattern.test(value);
        },
        "Por favor, ingresa solo números"
      );

      $.validator.addMethod(
        "rutDuplicado",
        function (value) {
          const studentsJson = localStorage.getItem("students");
          const students = Array.isArray(JSON.parse(studentsJson))
            ? JSON.parse(studentsJson)
            : [];
          return students.filter((student) => student.rut === value).length < 1;
        },
        "Este rut ya esta en la orden"
      );

      // Optional: To validate letters only but allow spaces
      $.validator.addMethod(
        "lettersonly",
        function (value) {
          if (!value) return false;

          // Remover espacios al inicio y final
          value = value.trim();

          // Verificar que no esté vacío después de remover espacios
          if (value.length === 0) return false;

          // Verificar que no sean solo espacios
          if (/^\s+$/.test(value)) return false;

          // Verificar que solo contenga letras y espacios
          var fullNamePattern = /^([a-zA-ZñÑáéíóúÁÉÍÓÚ]{1,}\s?)+$/;
          return fullNamePattern.test(value);
        },
        "Por favor, ingresa solo letras"
      );

      // Optional: To validate name length and format
      $.validator.addMethod(
        "validName",
        function (value, element) {
          if (!value) return false;

          // Remover espacios al inicio y final
          value = value.trim();

          // Verificar que no esté vacío después de remover espacios
          if (value.length === 0) return false;

          // Verificar que no sean solo espacios
          if (/^\s+$/.test(value)) return false;

          // Verificar longitud mínima (2 caracteres)
          if (value.length < 2) return false;

          // Verificar que solo contenga letras y espacios
          var fullNamePattern = /^([a-zA-ZñÑáéíóúÁÉÍÓÚ]{1,}\s?)+$/;
          return fullNamePattern.test(value);
        },
        "Por favor, ingresa un nombre válido (mínimo 2 caracteres, solo letras)"
      );

      // Optional: To validate date format dd/mm/aaaa
      $.validator.addMethod(
        "dateFormat",
        function (value) {
          if (!value) return false;

          // Verificar formato dd/mm/aaaa
          var datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
          if (!datePattern.test(value)) return false;

          var parts = value.split("/");
          var day = parseInt(parts[0], 10);
          var month = parseInt(parts[1], 10);
          var year = parseInt(parts[2], 10);

          // Validar rangos
          if (day < 1 || day > 31) return false;
          if (month < 1 || month > 12) return false;

          // Verificar que no sea en el futuro
          var currentDate = new Date();
          var inputDate = new Date(year, month - 1, day);
          if (inputDate > currentDate) return false;

          // Verificar que no sea muy antigua (antes de 1900)
          if (year < 1900) return false;

          // Verificar que la persona tenga al menos 10 años
          var minYear = currentDate.getFullYear() - 10;
          if (year > minYear) return false;

          // Validar meses con 30 días
          var months30 = [4, 6, 9, 11];
          if (months30.indexOf(month) !== -1 && day > 30) return false;

          // Validar febrero
          if (month === 2) {
            var isLeap =
              (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
            if (isLeap && day > 29) return false;
            if (!isLeap && day > 28) return false;
          }

          return true;
        },
        "Por favor, ingresa una fecha válida en formato dd/mm/aaaa"
      );

      // Optional: To validate email correctly
      $.validator.methods.email = function (value, element) {
        //return this.optional(element) || /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(value);
        return (
          this.optional(element) ||
          /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
            value
          )
        );
      };

      // Custom email validation method
      $.validator.addMethod(
        "customEmail",
        function (value, element) {
          if (!value) return false;

          // Verificar que tenga @ y punto
          if (value.indexOf("@") === -1 || value.indexOf(".") === -1)
            return false;

          // Verificar que no empiece o termine con @ o punto
          if (
            value.startsWith("@") ||
            value.endsWith("@") ||
            value.startsWith(".") ||
            value.endsWith(".")
          )
            return false;

          // Verificar que no tenga @ consecutivos
          if (value.includes("@@")) return false;

          // Verificar que el dominio tenga al menos 2 caracteres después del punto
          var parts = value.split("@");
          if (parts.length !== 2) return false;

          var domain = parts[1];
          var domainParts = domain.split(".");
          if (domainParts.length < 2) return false;

          var lastPart = domainParts[domainParts.length - 1];
          if (lastPart.length < 2) return false;

          return true;
        },
        "Por favor, ingresa un email válido"
      );

      // Default options, you can modify each option to be different on some forms passing an object
      // as 4 parameter of function
      let validateDefaultOptions = {
        ignore: "",
        rules: userRules,
        messages: userMessages,
        focusCleanup: true,
        focusInvalid: false,
        onkeyup: false,
        onclick: false,
        errorPlacement: function (error, element) {
          // Remover mensajes de error existentes
          element.closest('.form-group').find('label.error').remove();
          if (element.hasClass('withErrorContainer')) {
            error.appendTo(element.closest('.form-group').find('.errorContainer'));
          } else if (element.is('select')) {
            error.insertAfter(element.closest('.form-group').find('.select2.select2-container'));
          } else {
            error.insertAfter(element);
          }
          element.closest(".form-group").addClass("error");
        },
        // Clear error when required - Works if you follow the bootstrap html structure of forms
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass(errorClass).addClass(validClass);
          let $formGroup = $(element).closest(".form-group");
          $formGroup.removeClass("error");
          $formGroup.find("label.error").remove();
        },
      };

      let extraOptionsSelector = extraOptions || {};

      let validateOptions = $.extend(
        {},
        validateDefaultOptions,
        extraOptionsSelector
      );
      form.validate(validateOptions);
    },
  },
};
